import { useState, useEffect, useCallback, useRef } from 'react';
import { getEmailLog } from './api';

export default function useEmailLog({ page, pageSize, filters }) {
    const empty = { rows: [], total: 0, page: 1, pageSize, totalPages: 0 };
    const [data, setData] = useState(empty);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const fetchIdRef = useRef(0);

    const fetch = useCallback(async () => {
        const id = ++fetchIdRef.current;
        setLoading(true);
        setError(null);
        try {
            const params = { page, pageSize, ...filters };
            Object.keys(params).forEach((k) => {
                if (params[k] === '' || params[k] === undefined || params[k] === null) delete params[k];
            });
            const res = await getEmailLog(params);
            if (id === fetchIdRef.current) setData(res.data || empty);
        } catch (err) {
            if (id === fetchIdRef.current) setError(err.message || 'Failed to load email log');
        } finally {
            if (id === fetchIdRef.current) setLoading(false);
        }
    }, [page, pageSize, JSON.stringify(filters)]);

    useEffect(() => { fetch(); }, [fetch]);

    return { data, loading, error, refetch: fetch };
}
